var map = {
	"./1.png": "./src/images/gallery/Data Unleashed/1.png",
	"./2.png": "./src/images/gallery/Data Unleashed/2.png",
	"./3.png": "./src/images/gallery/Data Unleashed/3.png",
	"./4.png": "./src/images/gallery/Data Unleashed/4.png",
	"./cover.png": "./src/images/gallery/Data Unleashed/cover.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images/gallery/Data Unleashed sync \\.(png%7Cjpe?g%7Csvg)$";